module.exports = __webpack_public_path__ + "static/img/unknown-alert.d4e9606f.svg";